import React from 'react';

import { FilterType } from '@bytel/product-wall/types';

import { getWallConfig } from '@services/config';
import { odrService } from '@services/odr';
import { wallService } from '@services/products/wall';

import { WallType } from '@app-types/config';
import { SearchParamsType } from '@app-types/page';

import { TopBanner } from '@components/top-banner';

import { PAGE_SLUG } from '@helpers/partials';
import { getActiveFilters } from '@helpers/seo';

import { OdrWall } from './odr-wall';

interface OdrWallServerProps {
    searchParams?: SearchParamsType;
    filter?: string;
}

export async function OdrWallServer({ searchParams, filter }: Readonly<OdrWallServerProps>) {
    const wallConfig = getWallConfig(WallType.ODR);
    const urlSearchParams = new URLSearchParams(searchParams);
    const search = searchParams?.nom;
    const date = searchParams?.date;

    const universes = await odrService.getUniverses().catch(() => []);

    const dynamicFilters = universes.map(
        (universe) =>
            ({
                key: `universe_${universe.id}`,
                urlKey: universe.slug,
                label: universe.name,
                type: 'checkbox' as const,
                value: universe.slug,
                isHighlighted: true,
            }) as FilterType,
    );

    const dynamicWallConfig = {
        ...wallConfig,
        filters: dynamicFilters,
        filtersObject: dynamicFilters.reduce(
            (acc, filter) => {
                acc[filter.key] = filter;
                return acc;
            },
            {} as Record<string, FilterType>,
        ),
        filtersOrder: dynamicFilters.map((f) => f.key),
    };

    const activeFilters = getActiveFilters(dynamicWallConfig, (filter ?? '').toLowerCase(), urlSearchParams);

    const { products } = await wallService
        .getOdrProducts({
            filters: activeFilters,
            search,
        })
        .catch(() => ({ products: [] }));

    return (
        <>
            <TopBanner slug={PAGE_SLUG.ODR_WALL} />
            <OdrWall
                title={wallConfig.baseTitle}
                products={products}
                pageSize={wallConfig.productByPage}
                wallConfig={dynamicWallConfig}
                filters={dynamicFilters}
                activeFilters={activeFilters}
                searchParams={searchParams}
                search={search}
                date={date}
            />
        </>
    );
}
